export type InferredType = 'boolean' | 'integer' | 'decimal' | 'string' | 'money' | 'multiselect';

function isMoneyJson(v: unknown): v is { amount: string; currency: string; minor: number } {
    return (
        typeof v === 'object' && v !== null
        && 'amount' in v && typeof (v as Record<string, unknown>).amount === 'string'
        && 'currency' in v && typeof (v as Record<string, unknown>).currency === 'string'
        && 'minor' in v && typeof (v as Record<string, unknown>).minor === 'number'
    );
}

export function inferConfigSettingType(value: unknown): InferredType {
    // A string[] value is a multiselect (e.g. available_scheduling_methods) — infer it
    // even when the configOption relation is absent, so the badge/edit widget/save shape
    // stay correct rather than falling through to 'string'.
    if (Array.isArray(value)) return 'multiselect';
    if (isMoneyJson(value)) return 'money';
    if (typeof value === 'boolean') return 'boolean';
    if (typeof value === 'number') return Number.isInteger(value) ? 'integer' : 'decimal';
    if (typeof value === 'string') {
        if (value === 'true' || value === 'false') return 'boolean';
        if (/^-?\d+$/.test(value)) return 'integer';
        if (/^-?\d+\.\d+$/.test(value)) return 'decimal';
    }
    return 'string';
}
